import { render, staticRenderFns } from "./BookCosts.vue?vue&type=template&id=2826c65c"
import script from "./BookCosts.vue?vue&type=script&lang=js"
export * from "./BookCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports